import { render } from "./Slider.vue?vue&type=template&id=6c5c717b"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"
script.render = render

export default script